export const EXCHANGE_POLICY = {
  sameProduct: "same_product",
  upToSamePrice: "up_to_same_price",
  anyProduct: "any_product",
};

export function normalizeExchangePolicy(value) {
  if (value === EXCHANGE_POLICY.upToSamePrice || value === EXCHANGE_POLICY.anyProduct) {
    return value;
  }
  return EXCHANGE_POLICY.sameProduct;
}

export function policyCopy(policy) {
  const normalized = normalizeExchangePolicy(policy);
  switch (normalized) {
    case EXCHANGE_POLICY.upToSamePrice:
      return "A loja permite outro produto, desde que o preço seja igual ou menor que o item devolvido.";
    case EXCHANGE_POLICY.anyProduct:
      return "A loja permite qualquer produto em estoque. Se for mais caro, mostramos a diferença a pagar antes de confirmar.";
    case EXCHANGE_POLICY.sameProduct:
    default:
      return "A loja permite só outra variação (tamanho ou cor) do mesmo produto.";
  }
}

export function variantId(variant) {
  return variant?.variant_id || variant?.id || "";
}

export function variantPrice(variant, fallback = 0) {
  const raw = variant?.price ?? variant?.amount;
  if (raw === undefined || raw === null || raw === "") {
    return Number(fallback) || 0;
  }
  return Number(raw);
}

export function evaluateExchangeOption(item, candidate, policy) {
  const normalized = normalizeExchangePolicy(policy);
  const itemProduct = String(item?.product_id || item?.productId || "");
  const candidateProduct = String(candidate?.product_id || candidate?.productId || "");
  const fromPrice = Number(item?.price || 0);
  const toPrice = variantPrice(candidate, fromPrice);
  const dueAmount = Math.max(0, Math.round((toPrice - fromPrice) * 100) / 100);
  const sameProduct = !itemProduct || !candidateProduct || itemProduct === candidateProduct;

  if (normalized === EXCHANGE_POLICY.sameProduct && !sameProduct) {
    return {
      allowed: false,
      reason: "Este é outro produto. A loja só autoriza trocar tamanho ou cor do mesmo item.",
      dueAmount: 0,
    };
  }
  if (normalized === EXCHANGE_POLICY.upToSamePrice && toPrice > fromPrice + 0.009) {
    return {
      allowed: false,
      reason: "Custa mais que o item devolvido. A loja limita a troca ao mesmo valor.",
      dueAmount,
    };
  }
  return { allowed: true, reason: "", dueAmount };
}

export function flattenCatalog(entries, fallbackProductId) {
  const list = [];
  (entries || []).forEach((entry) => {
    if (entry?.variants) {
      entry.variants.forEach((variant) => {
        list.push({
          ...variant,
          product_id: variant.product_id || entry.product_id || entry.id || fallbackProductId,
          productTitle: entry.title || entry.name,
          image: variant.image || entry.image,
        });
      });
      return;
    }
    list.push({
      ...entry,
      product_id: entry.product_id || entry.productId || fallbackProductId,
    });
  });
  return list;
}

export function collectOptions(item, catalog, policy) {
  const local = (item?.availableVariants || []).map((variant) => ({
    ...variant,
    product_id: variant.product_id || item.product_id,
      productTitle: variant.productTitle || item.title,
    image: variant.image || item.image,
  }));
  const extra = flattenCatalog(catalog, item.product_id);
  const merged = [...local, ...extra];
  const seen = new Set();
  return merged
    .filter((variant) => {
      const id = String(variantId(variant));
      if (!id || seen.has(id)) {
        return false;
      }
      seen.add(id);
      return true;
    })
    .map((variant) => {
      const quantity = variant.inventoryQuantity ?? variant.inventory_quantity;
      const evaluated = evaluateExchangeOption(item, variant, policy);
      if (quantity !== undefined && quantity !== null && Number(quantity) <= 0) {
        return {
          variant,
          allowed: false,
          reason: "Sem estoque",
          dueAmount: evaluated.dueAmount,
        };
      }
      return {
        variant,
        ...evaluated,
      };
    });
}
